import { render, staticRenderFns } from "./oilsList.vue?vue&type=template&id=1b5ee3bf&scoped=true"
import script from "./oilsList.vue?vue&type=script&lang=js"
export * from "./oilsList.vue?vue&type=script&lang=js"
import style0 from "./oilsList.vue?vue&type=style&index=0&id=1b5ee3bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ee3bf",
  null
  
)

export default component.exports